<!-- <div *ngFor="let mail of mailTo">
    <div (click)="copyMailTo(mail);" class="actionPointer">
        {{mail}}
    </div>
</div> -->
<div (click)="copyMailTo(lastMailTo);" class="actionPointer">
    {{lastMailTo}}
</div>